<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="paddle_number"/>
            </div>
            <div class="input-wrapper">
              <bidder-select-input-widget @select="onBidderSelect"
                                          :model="searchModel"
                                          :label="false"
                                          :auction-uuid="extraFilters.auction_uuid"
                                          :options="{placeholder: $t('Bidder')}"
                                          value-field="uuid"
                                          attribute="bidder_uuid" is-search/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="lot_no"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" :label="false" attribute="type" value-field="value"
                            display-field="${item.key}" type="select2" :options="{placeholder: $t('Type')}"
                            :items="types"/>
            </div>
            <div class="input-wrapper">
              <input-widget type="select2" :items="clerks" :model="searchModel" attribute="clerk_uuid"
                            display-field="${item.name}" value-field="uuid" :label="false"
                            :options="{placeholder: $t('Clerk')}"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import i18n from "../../shared/i18n";
  import BidderSelectInputWidget from "@/core/widgets/BidderSelectInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('preBids');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "PreBidSearch",
    components: {BidderSelectInputWidget, InputWidget,},
    data() {
      return {
        types: [
          {value: 'commission', key: i18n.t('Commission'),},
          {value: 'telephone', key: i18n.t('Telephone'),},
          {value: 'max_bid', key: i18n.t('Max Bid'),},
        ],
      }
    },
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        extraFilters: state => state.tableData[state.tableSource].extraFilters,
      }),
      ...mapStateGlobal({
        clerks: state => state.currentUser.branch.clerks,
      }),
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage()
        this.getTableData();
      },
      onResetClick() {
        this.resetTable();
      },
      async onCustomerSelect(customer) {
        this.updateSearchModel({customer});
      },
      async onBidderSelect(bidder) {
        this.updateSearchModel({bidder});
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
